// The backend rotates the auth token on every call (new token comes back in
// the `authtoken` response header and the previous one is invalidated), so
// authenticated requests must go out strictly one at a time.

let tail = Promise.resolve();
let pendingCount = 0;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn());

export const subscribe = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const getPendingCount = () => pendingCount;

export const acquireSlot = () => {
  pendingCount += 1;
  notify();

  let resolveSlot;
  const slot = new Promise((resolve) => {
    resolveSlot = resolve;
  });
  const wait = tail;
  tail = tail.then(() => slot);

  let released = false;
  const release = () => {
    if (released) return;
    released = true;
    pendingCount -= 1;
    notify();
    resolveSlot();
  };

  return { wait, release };
};

// Lets non-API loading states (e.g. a mounted <Loader />) share the same
// single global loader. Returns a release function.
export const holdLoader = () => {
  pendingCount += 1;
  notify();

  let released = false;
  return () => {
    if (released) return;
    released = true;
    pendingCount -= 1;
    notify();
  };
};
